import { getApiClient } from '../api-client-factory';
import type { ApiResponse } from '../api-types';

/** Thin typed wrappers that unwrap the `{ success, data }` envelope. */
export async function get<T>(url: string, params?: Record<string, unknown>): Promise<T> {
  const res = await getApiClient().get<ApiResponse<T>>(url, { params });
  return res.data.data;
}
export async function post<T>(url: string, body?: unknown): Promise<T> {
  const res = await getApiClient().post<ApiResponse<T>>(url, body);
  return res.data.data;
}
export async function patch<T>(url: string, body?: unknown): Promise<T> {
  const res = await getApiClient().patch<ApiResponse<T>>(url, body);
  return res.data.data;
}
export async function put<T>(url: string, body?: unknown): Promise<T> {
  const res = await getApiClient().put<ApiResponse<T>>(url, body);
  return res.data.data;
}
export async function del<T>(url: string, params?: Record<string, unknown>): Promise<T> {
  const res = await getApiClient().delete<ApiResponse<T>>(url, { params });
  return res.data.data;
}
